<template>
  <div>
    <calling-code class="area-code"></calling-code>

    <div class="form-group phone-number">
      <label for="phone">{{ $t('phoneNumPlaceholder') }}</label>
      <input
        type="text"
        name="phone"
        id="phone"
        v-model="phoneNumber"
        :placeholder="$t('phoneNumPlaceholder')"
        v-validate="'required|numeric'"
        :class="{
          input: true,
          'danger-border': errors.has('phone') || !!phoneErrorMessage,
        }"
        @change="phoneErrorMessage = ''"
        @blur="showError.phone = true"
      />
      <p class="error-info">
        <span v-show="errors.has('phone') && showError.phone">{{
          errors.first("phone")
        }}</span>
        <span v-show="showError.phone">{{ phoneErrorMessage }}</span>
      </p>
    </div>
    <p class="clearfix"></p>

    <div class="form-group">
      <label for="pwd">{{ $t('passwordPlaceholder') }}</label>
      <input
        type="password"
        name="password"
        id="pwd"
        v-if="!isShowPwd"
        :placeholder="$t('passwordPlaceholder')"
        v-model.trim="password"
        v-validate="'required|min:6|max:20'"
        @blur="myValidate"
        :class="{
          'input pwd': true,
          'danger-border': errors.has('password') || !!pwdErrorMessage,
        }"
      />
      <input
        type="text"
        name="password"
        id="pwd"
        v-if="isShowPwd"
        :placeholder="$t('setPasswordPlaceholder')"
        v-model.trim="password"
        v-validate="'required|min:6|max:20'"
        @blur="myValidate"
        :class="{
          input: true,
          'danger-border': errors.has('password') || !!pwdErrorMessage,
        }"
      />
      <span class="show-pwd" @click="showPwd">
        <img src="/static/img/dashboard/ic_eye.svg" v-show="isShowPwd" alt="" />
        <img src="/static/img/dashboard/ic_eye_off.svg" v-show="!isShowPwd" alt="" />
      </span>
      <p class="error-info">
        <span v-show="errors.has('password') && showError.password">{{
          errors.first("password")
        }}</span>
        <!-- <span v-show="showError.password">{{ pwdErrorMessage }}</span> -->
      </p>
    </div>

    <button class="form-submit line-button return-data" v-if="!isLoading" @click="doLogin">
      {{ $t("loginText") }}
    </button>
    <spinner class="spinner-component" :show="isLoading"></spinner>
    <div class="forgot-password">
      <router-link to="/forgotpw">{{ $t("forgotPassword") }}</router-link>
      <router-link to="/register" class="register">{{ $t('signUp') }}</router-link>
    </div>
  </div>
</template>

<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../../assets/scss/formstyle";

div.form-group {
  input {
    margin-top: .08rem;
    height: .54rem;
    line-height: .54rem;
    border: 1px solid #E0D7E3;
    border-radius: 42px;
    padding: 0 24px;
    font-size: 16px;
    &::placeholder {
      color: #ccc;
    }
    &.pwd {
      padding-right: 50px;
    }
  }
  .show-pwd {
    right: 24px;
    bottom: 37px;
  }
}

.forgot-password {
  margin-top: 0.4rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  a {
    letter-spacing: 0;
    font-size: 16px;
    line-height: 0.16rem;
    color: #999999;
    &:first-child:hover {
      text-decoration: underline;
    }
    &.register {
      display: block;
      width: 120px;
      height: 44px;
      line-height: 44px;
      text-align: center;
      border: 1px solid #E0D7E3;
      border-radius: 42px;
      background: #FFF;
    }
  }
}

.form-submit {
  margin: .16rem 0 0;
  height: 54px;
  line-height: 54px;
  font-size: 18px;
  font-weight: 600;
  background-image: linear-gradient(125deg, #416CF8 0%, #EC55FF 100%);
  border-radius: 42px;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 4px;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(125deg, #416cf8 0%, #ec55ff 100%);
    border-radius: 42px;
    filter: blur(4px);
    -webkit-filter: blur(4px);
    -moz-filter: blur(4px);
    -ms-filter: blur(4px);
    -o-filter: blur(4px);
    z-index: -1;
  }
}

@media (max-width: 767px) {
  div.form-group {
    input {
      height: 0.49rem;
      line-height: .49rem;
      font-size: 14px;
      padding: 0 16px;
    }
    .show-pwd {
      right: 16px;
      bottom: 25px;
    }
  }
  .error-info {
    margin-top: 0.02rem;
  }
  .form-submit {
    margin-top: .24rem;
    height: 49px;
    line-height: 49px;
    font-size: 16px;
  }
  .forgot-password {
    margin-top: 0.24rem;
    flex-direction: column-reverse;
    a {
      width: 100%;
      &:first-child {
        font-size: 14px;
        line-height: 14px;
      }
      &.register {
        width: 100%;
        height: 49px;
        line-height: 49px;
        font-weight: 600;
        margin-bottom: 0.24rem;
      }
    }
  }
}
</style>

<script>
import Spinner from "../../Spinner.vue";
import CallingCode from "../../callingCode/IndexMain.vue";
import locales from "./lang";
import { mapState } from "vuex";
import { SET_USER_INFO } from "../../../store/mutation-types";

export default {
  name: "phone-login-view",
  components: {
    Spinner,
    CallingCode,
  },
  data: function () {
    return {
      phoneNumber: "",
      password: "",
      phoneErrorMessage: "",
      pwdErrorMessage: "",
      isLoading: false,
      showPasswordInput: false,
      isShowPwd: false,
      verificationCode: "",
      verificationCodeErrorMessage: "",
      timerText: this.$t("getVerificationCode"),
      isDisabled: false,
      sendCodeLoading: false,
      networkError: this.$t("networkError"),
      verificationCodeOrPwd: this.$t("verificationCodeOrPwd"),
      showError: {
        phone: false,
        code: false,
        password: false,
      },
    };
  },
  locales,
  watch: {
    phoneNumber() {
      this.showError.phone = false;
    },
    verificationCode() {
      this.showError.code = false;
      this.pwdErrorMessage = "";
      this.verificationCodeErrorMessage = "";
    },
    password() {
      this.showError.password = false;
      this.pwdErrorMessage = "";
      this.verificationCodeErrorMessage = "";
    },
  },
  computed: {
    hasCodeOrPwd() {
      return !!this.verificationCode || !!this.password;
    },
    dialCodeHasError() {
      return this.$store.state.dialCodeHasError;
    },
    ...mapState({
      dialCodeHasError: (state) => state.dialCodeHasError,
      redirectUrl: (state) => state.redirectUrl,
    }),
  },
  methods: {
    myValidate() {
      this.showError.code = true;
      this.showError.password = true;

      if (!!this.verificationCode || !!this.password) {
        this.pwdErrorMessage = "";
        this.verificationCodeErrorMessage = "";
      } else {
        this.pwdErrorMessage = this.verificationCodeOrPwd;
        this.verificationCodeErrorMessage = this.verificationCodeOrPwd;
      }
    },
    changeLoginMethod(currentMethod) {
      if (currentMethod === "pwd") {
        this.showPasswordInput = true;
        this.verificationCode = "";
      } else {
        this.showPasswordInput = false;
        this.password = "";
      }
    },
    sendVerificationCode: function () {
      if (this.showPasswordInput) {
        return;
      }
      this.showError.phone = true;
      if (this.errors.has("phone") || this.dialCodeHasError) {
        return;
      }
      this.isDisabled = true;
      this.$validator
        .validateAll({ phone: this.phoneNumber })
        .then((success) => {
          if (!success) {
            return;
          }
          this.phoneErrorMessage = "";
          this.sendCodeLoading = true;
          this.$http
            .post("api/verification/phone", {
              phone_num: this.phoneNumber,
              calling_code: this.$store.state.dialCode,
              type: "auth",
            })
            .then(
              (response) => {
                this.isDisabled = false;
                this.sendCodeLoading = false;
                switch (response.data.code) {
                  case 0: {
                    this.isDisabled = true;
                    break;
                  }
                  default: {
                    this.phoneErrorMessage = response.data.message;
                    break;
                  }
                }
              },
              (response) => {
                this.phoneErrorMessage = this.networkError;
                this.sendCodeLoading = false;
                this.isDisabled = false;
              }
            );
        });
    },
    showPwd: function () {
      this.isShowPwd = !this.isShowPwd;
    },
    doLogin: function () {
      // Event snippet for sign_in_phone page
      window.dataLayer && window.dataLayer.push({ event: "sign_in_phone" });
      for (let i in this.showError) {
        this.showError[i] = true;
      }
      if (this.errors.errors.length > 0) {
        return;
      }
      this.$validator.validateAll().then((success) => {
        if (!success) {
          return;
        }
        if (this.verificationCode === "" && this.password === "") {
          this.myValidate();
          return;
        }
        this.isLoading = true;
        this.$http
          .post("api/phone-login", {
            calling_code: this.$store.state.dialCode,
            phone_num: this.phoneNumber,
            verification_code:
              this.verificationCode === "" ? null : this.verificationCode,
            password: this.password === "" ? null : this.password,
            qr_token: window.sessionStorage.getItem("qr_token") || "",
          })
          .then(
            (response) => {
              this.isLoading = false;
              switch (response.data.code) {
                case 0: {
                  if (response.data.meta) {
                    this.$toast(response.data.meta.qr_message);
                  } else {
                    window.localStorage.setItem(
                      "token",
                      response.data.data.access_token
                    );
                    window.sessionStorage.setItem("needUseNoCache", true);
                    this.$store.commit(SET_USER_INFO, response.data.data);
                    this.$router.push(this.redirectUrl);
                  }
                  break;
                }
                case 103: {
                  this.pwdErrorMessage = response.data.message;
                  break;
                }
                case 120: {
                  this.verificationCodeErrorMessage = response.data.message;
                  break;
                }
                default: {
                  this.phoneErrorMessage = response.data.message;
                }
              }
            },
            (response) => {
              this.isLoading = false;
            }
          );
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// PhoneLogin.vue?a8d891f4